
import { config_path } from '../../router/config.path';
import { useNavigate } from 'react-router-dom';
import { portal_config } from '../../portal.config';
import LoginRegisterView from './LoginRegisterView';
import { useState } from 'react';
import { cache } from '../../utils/cache';
import crmservices from '../../wsclient';
import { checkAllowOrder } from '../../utils/common';
import LoadingComponent from '../../components/Loading';


export default function LoginRegisterController() {
    const navigate = useNavigate();
    const [showRegisterAction, setShowRegisterAction] = useState(false);
    const [showProcessing, setShowProcessing] = useState(false);

    const appConfig = cache.getAppConfig(false,true)
    const enableExistingCustomerFlow = appConfig && appConfig.features && appConfig.features.contact && appConfig.features.contact.contact && appConfig.features.contact.contact.enable_existing_customer_flow ? appConfig.features.contact.contact.enable_existing_customer_flow : null;
    const showContinueAsGuest = appConfig && appConfig.authentication && appConfig.authentication.guest_contact && appConfig.authentication.guest_contact.is_supported;
    
    const onRegister = () => {
        if(enableExistingCustomerFlow) {
            setShowRegisterAction(true);
        } else {
            navigate(config_path.register);
        }
    }

    const onLogin = () => {
        navigate(config_path.login);
    }

      const onLoginGuest = async () => {
        setShowProcessing(true);
        let startSession =  true;
        let result = await crmservices.authentication.authenticateGuest({ }, startSession);
        if(result && result.code == 'OK'){
            let accessToken = result.data && result.data.access_token ? result.data.access_token : null;
            if(accessToken) {
                let session = await crmservices.getSession();
                if(session && session.type && session.type.toLowerCase() === "guest"){
                    cache.setIsAlreadyWallet(true);
                    cache.setIsGuest(true);          
                    await checkAllowOrder(appConfig); 
                }
            }
        }
        setShowProcessing(false); 
        navigate(config_path.login);
    }

    return (
        <>
            {showProcessing && <LoadingComponent showLoading={showProcessing} />}
            <LoginRegisterView
                onRegister={onRegister}
                onLogin={onLogin}
                onLoginGuest={onLoginGuest}
                showRegisterAction={showRegisterAction}
                setShowRegisterAction={setShowRegisterAction}
                showContinueAsGuest={showContinueAsGuest}
            />
        </>
    )
}
